export const history = [
  {
    title: "Anul infiintarii 2007",
    text:
      "It is a long established fact that a reader will be distracted by the readable content of a page when looking at its layout. ",
  },
  {
    title: "Deschidere ITP Ciorani",
    text:
      " It is a long established fact that a reader will be distracted by the readable content of a page when looking at its layout. ",
  },
  {
    title: "Infiintare Chedra Tax Floresti",
    text:
      "It is a long established fact that a reader will be distracted by the readable content of a page when looking at its layout. ",
  },
  {
    title: "2015 - Vulcanizare",
    text:
      " It is a long established fact that a reader will be distracted by the readable content of a page when looking at its layout. ",
  },
  {
    title: "Toate bune si frumoase",
    text:
      " It is a long established fact that a reader will be distracted by the readable content of a page when looking at its layout. ",
  },
]

export const years = [
  { year: "2007 - Infiintare Chedra Tax Ploiesti" },
  { year: "2009 - Deschidere ITP Ciorani" },
  { year: "2011 - Infiintare Chedra Tax Floresti" },
  { year: "2015 - Vulcanizare" },
  { year: "2020 - Toate bune si frumoase" },
]
